import { CompanyFormikMultiselectFormField } from 'components/molecules/MultiselectFormField/CompanyFormikMultiselectFormField';
import { useField, useFormikContext } from 'formik';
import { ProjectStatus } from 'generated/graphql';
import {
  Checkbox,
  FormikTextInputField,
  MultiselectFormField,
  SegmentedControl,
  TMultiselectOption,
} from '@spotted-zebra-uk/ui-components';
import styles from './ProjectFilterModal.module.scss';
import HiringTeamUsersField from './HiringTeamUsersField';
import { FiltersFormValues } from './ProjectsFilterModal';
import {
  ATS_LINKED_OPTIONS,
  AtsLinkedFilter,
} from './ProjectsFilterModal.constants';

const statusSelectOptions: TMultiselectOption<ProjectStatus>[] = [
  { label: 'Draft', value: ProjectStatus.Draft },
  { label: 'In Review', value: ProjectStatus.Review },
  { label: 'Published', value: ProjectStatus.Published },
  { label: 'Closed', value: ProjectStatus.Closed },
];

const RoleTabContent = () => {
  const { values, setFieldValue } = useFormikContext<FiltersFormValues>();

  const handleCheck = () => {
    setFieldValue('isArchived', !values.isArchived);
  };

  const handleSelectStatus = (newValue: TMultiselectOption<string>[]) => {
    setFieldValue('status', newValue);
  };

  return (
    <>
      <CompanyFormikMultiselectFormField
        id="companies"
        label="Companies"
        placeholder="Companies"
      />
      <HiringTeamUsersField />
      <MultiselectFormField
        id="status"
        name="status"
        placeholder="Status"
        label="Status"
        onChange={handleSelectStatus}
        value={values.status}
        options={statusSelectOptions}
        maxMenuHeight={400}
      />
      <Checkbox
        label="Include archived roles"
        checked={values.isArchived}
        onChange={handleCheck}
      />
      <div className={styles.segmentedRow}>
        <span>Requisition linked</span>
        <SegmentedControl.Root
          size="small"
          value={values.atsLinked}
          onValueChange={value =>
            setFieldValue('atsLinked', value as AtsLinkedFilter)
          }
          aria-label="Requisition linked"
        >
          {ATS_LINKED_OPTIONS.map(atsOption => (
            <SegmentedControl.Item key={atsOption.value} value={atsOption.value}>
              {atsOption.label}
            </SegmentedControl.Item>
          ))}
        </SegmentedControl.Root>
      </div>
      <div className={styles.section}>
        <p className={styles.dateFieldsTitle}>Candidates on role</p>
        <div className={styles.fieldsRow}>
          <FormikTextInputField
            id="projectCandidatesFrom"
            label="From"
            ariaLabel="Candidates on role, from"
            useFormikField={useField}
            placeholder="From"
          />
          <FormikTextInputField
            id="projectCandidatesTo"
            label="To"
            ariaLabel="Candidates on role, to"
            useFormikField={useField}
            placeholder="To"
          />
        </div>
      </div>
    </>
  );
};

export default RoleTabContent;
